export default class PasswordInput {
  constructor(node) {
    this.passwordInput = node.querySelector(".js-password-input");
    this.toggleVisiblityElement = node.querySelector(".js-toggle-visiblity");
    this.toggleVisiblityElementIcon = this.toggleVisiblityElement.querySelector(".icon");

    this.toggleVisiblityElement.addEventListener("click", () => {
      this.togglePasswordVisibility();
    });
  }

  togglePasswordVisibility() {
    this.toggleVisiblityElementIcon.classList = "icon";
    if (this.passwordInput.type === "password") {
      this.passwordInput.type = "text";
      this.toggleVisiblityElementIcon.classList.add("icon-eye-open");
    } else {
      this.passwordInput.type = "password";
      this.toggleVisiblityElementIcon.classList.add("icon-eye-closed");
    }
  }
}
